// extracted by mini-css-extract-plugin
export default {"rootSmall":"Breadcrumb-rootSmall_v1i5U","root":"Breadcrumb-root_xqzux","active":"Breadcrumb-active_gskjq"};